export default {
      id: "email-usage",
      viewBox: "0 0 60 60",
      url: __webpack_public_path__ + "img/icons.1563a6ab.svg#email",
      toString: function () {
        return this.url;
      }
    }